"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var BANNER_SELECTOR = '.coBannerKaitoriBonusCampaignOtherPosition-Container';
/**
 * Hides the first banner when two banners with the same class are consecutive,
 * or when the only element between them is a nav.pagination.paging-navigation.
 */
var DuplicateKaitoriBannerController = /** @class */ (function (_super) {
    __extends(DuplicateKaitoriBannerController, _super);
    function DuplicateKaitoriBannerController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DuplicateKaitoriBannerController.prototype.connect = function () {
        this.hideConsecutiveDuplicates();
    };
    DuplicateKaitoriBannerController.prototype.hideConsecutiveDuplicates = function () {
        var banners = Array.from(this.element.querySelectorAll(BANNER_SELECTOR));
        if (banners.length < 2) {
            return;
        }
        var root = this.element;
        for (var i = 0; i < banners.length - 1; i++) {
            var current = banners[i];
            var nextInList = banners[i + 1];
            var nextBanner = this.findNextBannerInDom(current, root, banners);
            if (nextBanner === nextInList) {
                current.style.display = 'none';
                current.setAttribute('aria-hidden', 'true');
                break;
            }
        }
    };
    /**
     * Finds the next banner in DOM order from el, allowing one nav.pagination.paging-navigation in between.
     */
    DuplicateKaitoriBannerController.prototype.findNextBannerInDom = function (el, root, banners) {
        var next = this.nextElementInDocumentOrder(el, root);
        if (!next) {
            return null;
        }
        if (banners.includes(next)) {
            return next;
        }
        if (next.tagName === 'NAV' &&
            next.classList.contains('pagination') &&
            next.classList.contains('paging-navigation')) {
            var afterNav = this.nextElementInDocumentOrder(next, root);
            if (afterNav && banners.includes(afterNav)) {
                return afterNav;
            }
        }
        return null;
    };
    DuplicateKaitoriBannerController.prototype.nextElementInDocumentOrder = function (el, root) {
        var next = el.nextElementSibling;
        if (next) {
            return next;
        }
        var parent = el.parentElement;
        while (parent && parent !== root) {
            next = parent.nextElementSibling;
            if (next) {
                return next;
            }
            parent = parent.parentElement;
        }
        return null;
    };
    return DuplicateKaitoriBannerController;
}(stimulus_1.Controller));
exports.default = DuplicateKaitoriBannerController;
